import * as React from "react";
import { forwardRef } from "react";
const SvgLevel = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 105, viewBox: "0 0 64 105", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { id: "Subtract", fillRule: "evenodd", clipRule: "evenodd", d: "M64 104.5H12L0 92.5V0.5H64V104.5Z", fill: "#1E293B" }));
const ForwardRef = forwardRef(SvgLevel);
export { ForwardRef as ReactComponent };
